import { Specialist } from '@/types/HospitalDetail'

const setDetailDocumentTitle = (data: any) => {
  const baseTitle =
    document.title.indexOf(' | ') > -1
      ? document.title.split(' | ')[1]
      : document.title

  const params: any = {}
  location.search
    .substring(1)
    .split('&')
    .forEach((param) => {
      const a = param.split('=')
      params[a[0]] = a[1]
    })
  let titleStr = data.hospital_name

  if (params.tab && params.tab === 'early') titleStr += 'の初期研修・求人情報'
  if (params.tab && params.tab === 'events') titleStr += 'の参加イベント'
  if (params.tab && params.tab === 'latter') {
    if (params.id) {
      const result = data.specialist.find(
        (el: Specialist) => el.s_training_id == Number(params.id)
      )
      titleStr += result ? `の${result.program}` : ''
    } else {
      titleStr += 'の専門研修プログラム一覧'
    }
  }
  document.title = `${titleStr} | ${baseTitle}`
}

export { setDetailDocumentTitle }
